import api from "./api";
import packageJson from "../../package.json";

const getHome = async () => await api.get('home/',{
    params:{
        appVersionName:packageJson.version,appVersionCode:packageJson.versionCode,deviceOSVersion:"site"
    }
})
const getHomeRow = async (homeRowId,page) => await api.get(`homeRow/${homeRowId}/courses`, {
    params: {
        offset: page * global.PAGE_SIZE, limit: global.PAGE_SIZE
    }
})
export default {getHome,getHomeRow}
